export const subscribeToPlan = /* GraphQL */ `
  mutation SubscribeToPlan($input: SubscribeToPlanVersionInput!) {
    subscribeToPlan(input: $input) {
      ... on SubscribeToPlanVersionValidationFailed {
        __typename
        errorMessage
        errorCode
      }
      ... on InvalidField {
        __typename
        errorMessage
        fieldName
        errorCode
      }
      ... on AccountNotFound {
        __typename
        errorMessage
        providerId
        errorCode
        accountId
      }
      ... on PlanVersionIsNotAssignable {
        __typename
        errorMessage
        providerId
        planVersionId
        errorCode
      }
      ... on PlanVersionNotFound {
        __typename
        errorMessage
        planVersionId
        providerId
        errorCode
      }
      ... on PlanAliasNotFound {
        __typename
        errorMessage
        planId
        providerId
        errorCode
      }
      ... on PlanAliasNotActive {
        __typename
        errorMessage
        planId
        providerId
        errorCode
      }
      ... on PlanNotFound {
        __typename
        errorMessage
        planId
        providerId
        errorCode
      }
      ... on SubscriptionNotFound {
        __typename
        errorMessage
        errorCode
        planSubscriptionId
      }
      ... on InternalServerError {
        __typename
        errorMessage
        errorCode
      }
      ... on InvalidProviderLifecycleStage {
        __typename
        errorMessage
        errorCode
        providerLifecycleStage
      }
      ... on RateLimitExceeded {
        __typename
        errorMessage
        errorCode
        providerId
        retryAfter
      }
      ... on FeatureNotEnabled {
        __typename
        errorMessage
        errorCode
        providerId
        featureName
      }
      ... on SubscribeToPlanVersionPayload {
        __typename
        subscribedPlanVersion {
          to
          from
          planVersion {
            version
            state
            id
          }
        }
        account {
          customData
          id
          activePlanVersions {
            from
            to
            planVersion {
              plan {
                name
              }
              version
              state
              id
            }
          }
          archivedPlanVersions {
            to
            from
            planVersion {
              plan {
                name
              }
              version
              state
              id
            }
          }
          inactivePlanVersions {
            to
            planVersion {
              plan {
                name  
              }
              state
              version
              id
            }
            from
          }
        }
      }
    }
  }
`

export const updateBalanceMutation = /* GraphQL */ `
  mutation UpdateBalance($input: UpdateBalanceInput!) {
    updateBalance(input: $input) {
      ... on BalancePayload {
        providerId
        accountId
        balanceInfo {
          balanceId
          balanceType {
            balanceTypeId
            name
            limit
          }
          priority
          value
          total
          limit
          used
          available
        }
      }
      ... on BalanceNotFound {
        providerId
        balanceId
        errorCode
        errorMessage
      }
      ... on BalanceTypeNotFound {
        providerId
        balanceTypeId
        errorCode
        errorMessage
      }
      ... on AccountNotFound {
        providerId
        accountId
        errorCode
        errorMessage
      }
      ... on InvalidField {
        fieldName
        errorCode
        errorMessage
      }
      ... on RateLimitExceeded {
        providerId
        retryAfter
        errorCode
        errorMessage
      }
      ... on InternalServerError {
        errorCode
        errorMessage
      }
    }
  }
`
